import SchoolGallery from "../components/pages/SchoolGallery";

export default SchoolGallery;
